export enum NavPages {
    Root,
    Login,
    Signup,
    QuizSelector,
    Quiz,
    EditQuestions,
    EditQuiz,
    QuizSession,
    QuizSessionOverview,
    QuizSessionPresent,
    CreateQuizSession,
    Profile,
    PrintAnswerSheet
}

export class NavUtils {
    public static getQuizSelectorPath(eventAlias?: string) {
        return this.generateNavPath(NavPages.QuizSelector, undefined, eventAlias);
    }

    public static generateNavPath(page: NavPages, quizId?: number, eventAlias?: string, sessionKey?: string) {
        switch (page) {
            case NavPages.Root:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/`;
            case NavPages.Login:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/login`;
            case NavPages.Signup:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/signup`;
            case NavPages.Profile:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/profile`;
            case NavPages.EditQuestions:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/quiz/${quizId}/questions/edit`;
            case NavPages.Quiz:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/quiz/${quizId}`;
            case NavPages.EditQuiz:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/quiz/${quizId}/edit`;
            case NavPages.QuizSession:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/quiz/${quizId}/session/${sessionKey}`;
            case NavPages.QuizSessionOverview:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/quiz/${quizId}/session/${sessionKey}/overview`;
            case NavPages.QuizSessionPresent:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/quiz/${quizId}/session/${sessionKey}/present`;
            case NavPages.CreateQuizSession:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/quiz/${quizId}/session`;
            case NavPages.PrintAnswerSheet:
                return `${!!eventAlias ? `/${eventAlias}` : ''}/quiz/${quizId}/answer-sheet-print`;
            case NavPages.QuizSelector:
            default:
                return eventAlias ? `/${eventAlias}` : '/quiz-selector';
        }
    }

    public static generateAbsolutePath(page: NavPages, quizId?: number, eventAlias?: string, sessionKey?: string) {
        return `${window.location.origin}${this.generateNavPath(page, quizId, eventAlias, sessionKey)}`;
    }
}
